import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { ProjectsStore, ProjectsState } from './projects.store';

@Injectable({
	providedIn: 'root'
})
export class ProjectsQuery extends QueryEntity<ProjectsState> {
	totalElements = this.select(state => state.ui.totalElements);

	constructor(protected store: ProjectsStore) {
		super(store);
	}
}